import React, { useState, useMemo } from 'react';
import { Container, Col, Row } from "react-bootstrap";
import { StyledKfTable } from '../../../../Styling/styledTable/StyledTable';
import usePaginator from '../../../../components/useTable/UsePaginator';
import UseTableSorter from '../../../../components/useTable/UseTable';
import styled from 'styled-components';
import colorConfig from '../../../../colorConfig';
import { TableBorder, TitleSectionTables, KredittvurderingForm, KredittvurderingTd, StyledKvTable } from '../../../../Styling/styledKredittvurdering/styledKvComponents';
import ExpandedEiendomTable from './ExpandedEiendomTable';


const EiendomTable = (props) => {

    const localeMessages = props.localeMessages
    const kvState = props.kredittvurderingState;
    const ratingData = props.fetchedRating;

    // State for grid sorting
    const [currentSeq, setCurrentSeq] = useState('up'); // default
    const [currentField, setCurrentField] = useState('debtorName');    // feltnavn
    const [currentType, setCurrentType] = useState('string'); // num
    const [sortClicked, setSortClicked] = useState(0);

    const [masterT1ChangeSortField, t1GetSortFunc, t1IndicaterIcon] = UseTableSorter(
        currentSeq, setCurrentSeq,
        currentField, setCurrentField,
        currentType, setCurrentType
    )

    // Nødvendig pga henting av memoised felt
    const t1ChangeSortField = (fieldName, fieldType) => {
        masterT1ChangeSortField(fieldName, fieldType)

        // Sett trigger for å tvinge memoized function til rerender
        setSortClicked(Date.now())
    }

    const sortedData = useMemo(
        () => {
            if (ratingData.length > 0) {
                return ratingData.sort(t1GetSortFunc().fn)
            }
            else {
                return []
            }
        },
        [ratingData, sortClicked]
    );

    // state for grid paginator
    const [numberPrPage, setNumberPerPage] = useState(5)
    const [activePage, setActivePage] = useState(1);
    const [showAll, setShowAll] = useState(false);


    const [Paginate, PaginationNav, PaginationDropdown, PaginationIndex, resetPagination] = usePaginator(
        sortedData,
        numberPrPage, setNumberPerPage,
        activePage, setActivePage
    )

    const [expanded, setExpanded] = useState(null);

    const handleRowClick = (i) => {
        setExpanded(prev => (prev === i ? null : i));
    };

    
    const printHeader = (t1IndicaterIcon, t1ChangeSortField) => {
      return (
          <thead>
              <tr>
                  <th style={{ fontSize: 'clamp(10px, 0.65vw, 20px)', whiteSpace: 'normal', overflowWrap: 'break-word', backgroundColor: 'white' }} onClick={() => t1ChangeSortField('liensLength', 'num')}>{localeMessages['GH_antallHeftelser']}{t1IndicaterIcon('liensLength')}</th>
                  <th style={{ fontSize: 'clamp(10px, 0.65vw, 20px)', whiteSpace: 'normal', overflowWrap: 'break-word', backgroundColor: 'white' }} onClick={() => t1ChangeSortField('propertyType', 'string')}>{localeMessages['GH_eiendomstype']}{t1IndicaterIcon('propertyType')}</th>
                  <th style={{ fontSize: 'clamp(10px, 0.65vw, 20px)', whiteSpace: 'normal', overflowWrap: 'break-word', backgroundColor: 'white' }} onClick={() => t1ChangeSortField('type', 'string')}>{localeMessages['GH_formaal']}{t1IndicaterIcon('type')}</th>
                  <th style={{ fontSize: 'clamp(10px, 0.65vw, 20px)', whiteSpace: 'normal', overflowWrap: 'break-word', backgroundColor: 'white' }} onClick={() => t1ChangeSortField('ownershipRights', 'string')}>{localeMessages['GH_hjemmel']}{t1IndicaterIcon('ownershipRights')}</th>
                  <th style={{ fontSize: 'clamp(10px, 0.65vw, 20px)', whiteSpace: 'normal', overflowWrap: 'break-word', backgroundColor: 'white' }} onClick={() => t1ChangeSortField('shareOfOwnership', 'num')}>{localeMessages['GH_eierskapBroek']}{t1IndicaterIcon('shareOfOwnership')}</th>
                  <th style={{ fontSize: 'clamp(10px, 0.65vw, 20px)', whiteSpace: 'normal', overflowWrap: 'break-word', backgroundColor: 'white' }} onClick={() => t1ChangeSortField('registerUnitId', 'num')}>{localeMessages['GH_registerenhetId']}{t1IndicaterIcon('registerUnitId')}</th>
                  <th style={{ fontSize: 'clamp(10px, 0.65vw, 20px)', whiteSpace: 'normal', overflowWrap: 'break-word', backgroundColor: 'white' }} onClick={() => t1ChangeSortField('address', 'string')}>{localeMessages['GH_adresse']}{t1IndicaterIcon('address')}</th>
                  <th style={{ fontSize: 'clamp(10px, 0.65vw, 20px)', whiteSpace: 'normal', overflowWrap: 'break-word', backgroundColor: 'white' }} onClick={() => t1ChangeSortField('zipCode', 'num')}>{localeMessages['GH_postnummer']}{t1IndicaterIcon('zipCode')}</th>
                  <th style={{ fontSize: 'clamp(10px, 0.65vw, 20px)', whiteSpace: 'normal', overflowWrap: 'break-word', backgroundColor: 'white' }} onClick={() => t1ChangeSortField('postalAddress', 'string')}>{localeMessages['GH_poststed']}{t1IndicaterIcon('postalAddress')}</th>
                  <th style={{ fontSize: 'clamp(10px, 0.65vw, 20px)', whiteSpace: 'normal', overflowWrap: 'break-word', backgroundColor: 'white' }} onClick={() => t1ChangeSortField('previousSaleDate', 'datetime')}>{localeMessages['GH_forrigeOmsetningstidspunkt']}{t1IndicaterIcon('previousSaleDate')}</th>
                  <th style={{ fontSize: 'clamp(10px, 0.65vw, 20px)', whiteSpace: 'normal', overflowWrap: 'break-word', backgroundColor: 'white' }} onClick={() => t1ChangeSortField('previousSalePrice', 'num')}>{localeMessages['GH_forrigeOmsetningspris']}{t1IndicaterIcon('previousSalePrice')}</th>
                  <th style={{ fontSize: 'clamp(10px, 0.65vw, 20px)', whiteSpace: 'normal', overflowWrap: 'break-word', backgroundColor: 'white' }} onClick={() => t1ChangeSortField('estimatedPrice', 'num')}>{localeMessages['GH_estimertPris']}{t1IndicaterIcon('estimatedPrice')}</th>
                  <th style={{ fontSize: 'clamp(10px, 0.65vw, 20px)', whiteSpace: 'normal', overflowWrap: 'break-word', backgroundColor: 'white' }} onClick={() => t1ChangeSortField('propertyType', 'string')}>{localeMessages['GH_brukstype']}{t1IndicaterIcon('propertyType')}</th>
                  <th style={{ fontSize: 'clamp(10px, 0.65vw, 20px)', whiteSpace: 'normal', overflowWrap: 'break-word', backgroundColor: 'white' }} onClick={() => t1ChangeSortField('type', 'string')}>{localeMessages['GH_boligtype']}{t1IndicaterIcon('type')}</th>
                  <th style={{ fontSize: 'clamp(10px, 0.65vw, 20px)', whiteSpace: 'normal', overflowWrap: 'break-word', backgroundColor: 'white' }} onClick={() => t1ChangeSortField('municipalityNumber', 'num')}>{localeMessages['GH_kommunenummer']}{t1IndicaterIcon('municipalityNumber')}</th>
                  <th style={{ fontSize: 'clamp(10px, 0.65vw, 20px)', whiteSpace: 'normal', overflowWrap: 'break-word', backgroundColor: 'white' }} onClick={() => t1ChangeSortField('cadastralUnitNumber', 'num')}>{localeMessages['GH_gaardsnummer']}{t1IndicaterIcon('cadastralUnitNumber')}</th>
                  <th style={{ fontSize: 'clamp(10px, 0.65vw, 20px)', whiteSpace: 'normal', overflowWrap: 'break-word', backgroundColor: 'white' }} onClick={() => t1ChangeSortField('unitNumber', 'num')}>{localeMessages['GH_bruksnummer']}{t1IndicaterIcon('unitNumber')}</th>
              </tr>
          </thead>
      )
    }


    const printRow = (model) => {
        return (
            <>
            <tr key={model.j} onClick={() => handleRowClick(model.j)} style={{ cursor: 'pointer' }} >
               <KredittvurderingTd>
                    {model.liensLength > 0
                        ? expanded === model.j
                            ? (
                            <svg xmlns="http://www.w3.org/2000/svg" fill="currentColor" viewBox="0 0 24 24" width="24" height="24">
                                <path d="M7 10l5 5 5-5z" />
                            </svg>
                            )
                            : (
                            <svg xmlns="http://www.w3.org/2000/svg" fill="currentColor" viewBox="0 0 24 24" width="24" height="24">
                                <path d="M12 7l5 5-5 5" />
                            </svg>
                            )
                        : (
                        <svg xmlns="http://www.w3.org/2000/svg" fill="transparent" viewBox="0 0 24 24" width="24" height="24">
                            <path d="M12 7l5 5-5 5" />
                        </svg>
                        )
                    }
                <>&nbsp;({model.liensLength ?? '0'})</>
               </KredittvurderingTd>
               <KredittvurderingTd style={{ fontSize: 'clamp(12px, 0.65vw, 20px)' }} >{model.info.propertyType}</KredittvurderingTd>
               <KredittvurderingTd style={{ fontSize: 'clamp(12px, 0.65vw, 20px)' }} >{model.info.type}</KredittvurderingTd>
               <KredittvurderingTd style={{ fontSize: 'clamp(12px, 0.65vw, 20px)' }} >{model.info.ownershipRights}</KredittvurderingTd>
               <KredittvurderingTd style={{ fontSize: 'clamp(12px, 0.65vw, 20px)' }} >{model.info.shareOfOwnership}</KredittvurderingTd>
               <KredittvurderingTd style={{ textAlign: 'right', fontSize: 'clamp(12px, 0.65vw, 20px)' }} >{model.info.registerUnitId}</KredittvurderingTd>
               <KredittvurderingTd style={{ fontSize: 'clamp(12px, 0.65vw, 20px)' }} >{model.info.address}</KredittvurderingTd>
               <KredittvurderingTd style={{ fontSize: 'clamp(12px, 0.75vw, 20px)' }} >{model.info.zipCode}</KredittvurderingTd>
               <KredittvurderingTd style={{ textAlign: 'right', fontSize: 'clamp(12px, 0.65vw, 20px)' }} >{model.info.postalAddress}</KredittvurderingTd>
               <KredittvurderingTd style={{ fontSize: 'clamp(12px, 0.75vw, 20px)' }} >{model.valuation.previousSaleDate}</KredittvurderingTd>
               <KredittvurderingTd style={{ textAlign: 'right', fontSize: 'clamp(12px, 0.65vw, 20px)' }} >{model.valuation.previousSalePrice}</KredittvurderingTd>
               <KredittvurderingTd style={{ textAlign: 'right', fontSize: 'clamp(12px, 0.65vw, 20px)' }} >{model.valuation.estimatedPrice}</KredittvurderingTd>
               <KredittvurderingTd style={{ fontSize: 'clamp(12px, 0.65vw, 20px)' }} >{model.info.propertyType}</KredittvurderingTd>
               <KredittvurderingTd style={{ fontSize: 'clamp(12px, 0.65vw, 20px)' }} >{model.info.type}</KredittvurderingTd>
               <KredittvurderingTd style={{ textAlign: 'right', fontSize: 'clamp(12px, 0.65vw, 20px)' }} >{model.info.municipalityNumber}</KredittvurderingTd>
               <KredittvurderingTd style={{ textAlign: 'right', fontSize: 'clamp(12px, 0.65vw, 20px)' }} >{model.info.cadastralUnitNumber}</KredittvurderingTd>
               <KredittvurderingTd style={{ textAlign: 'right', fontSize: 'clamp(12px, 0.65vw, 20px)' }} >{model.info.unitNumber}</KredittvurderingTd>
           </tr>
           {(expanded === model.j) && model.liensLength !== 0 && (
                <>
                    <tr key={model.j + 1000} style={{ backgroundColor: 'white', hover: { opacity: 1 } }} >
                        <td colspan="17" className={expanded ? 'expand-animation' : 'minimize-animation'}>
                            <ExpandedEiendomTable tableData={model.liens} shareOfOwnership={model.info.shareOfOwnership} localeMessages={props.localeMessages} />
                        </td>
                    </tr>
                </>
            )}
            </>
        )
    }

    return (
        <>
            <Container fluid="true">
                <TableBorder>
                    <KredittvurderingForm>
                        <Col xs={12} md={12}>
                            <TitleSectionTables>Eiendom</TitleSectionTables>
                            <PaginationDropdown />
                            <StyledKvTable>
                                {printHeader(t1IndicaterIcon, t1ChangeSortField)}
                                <tbody>
                                    <Paginate>
                                        {/* paginate forventer en funksjon */}
                                        {row => printRow(row)}
                                    </Paginate>
                                </tbody>
                            </StyledKvTable>
                            <br />
                            <PaginationIndex />
                            <br />
                            <PaginationNav />
                            <br/>
                        </Col>
                    </KredittvurderingForm>
                </TableBorder>            
            </Container>
            
        </>
    )
}

export default EiendomTable



